export interface PnkTabChange {
  index: number;
  label: string;
  active: boolean;
}
